import { Box, Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Global_Data } from '../../globalData/GlobalData';
import { Document, Page } from 'react-pdf';

const ReportBrowser = ({ data, formData, sethandleModalclick, reportData }) => {

    const { setOpen, setOpenModalChildData } = Global_Data();
    const [numPages, setNumPages] = useState(null);

    const handleClickOpen = () => {
        sethandleModalclick(true);
        setOpenModalChildData(formData?.details?.[1]?.child);
        setOpen(true)
    }

    const pageStyle = {
        width: "100px",
        height: "auto",
        margin: "0 auto",
        display: "block"
    };

    return (
        <React.Fragment>
            <Grid item {...data.component.sButton.grid_props}>
                <Button
                    {...data.component.sButton.sButtonProps}
                    sx={{ ...data.component.sButton.sButtonProps }}
                    onClick={handleClickOpen}
                    id={`${data?.component?.sName}_button`}
                >
                    {data.component.sButton.sButtonLabel}
                </Button>
            </Grid>
            {reportData &&
                <Grid item {...data.component?.previewSection?.grid_props}>
                    <Box id={data.component?.previewSection?.box?.sName} {...data.component?.previewSection?.box?.sProps}>
                        {data?.component?.previewSection?.data?.sAction == "PDF" &&
                            <iframe
                                src={reportData}
                                width="100%"
                                height="800px"
                                style={{ border: 'none' }}
                                title="PDF Viewer"
                            />
                        }
                    </Box>
                </Grid>
            }
        </React.Fragment>
    )
}

export default ReportBrowser